import { useQuery } from "@tanstack/react-query";
import { formatMoney } from "@melhot/shared/money";
import { adminApi } from "../api";
import { EmptyState, Panel } from "../components/DataTable";

export function CheckoutsPage() {
  const query = useQuery({ queryKey: ["admin-checkouts"], queryFn: adminApi.checkouts, refetchInterval: 5000 });
  return (
    <Panel title="Checkouts">
      {!query.data?.length ? <EmptyState text="Nenhum checkout em memoria local ainda." /> : (
        <div className="overflow-auto">
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead className="text-xs uppercase text-slate-500"><tr><th className="py-2">ID</th><th>Status</th><th>Cliente</th><th>Total</th><th>Frete</th><th>Ultima atividade</th></tr></thead>
            <tbody>
              {query.data.map((item) => (
                <tr key={item.publicId} className="border-t border-line">
                  <td className="py-2 font-mono text-xs">{item.publicId}</td>
                  <td>{item.status}</td>
                  <td>{item.email ?? "-"}</td>
                  <td>{formatMoney(item.total ?? 0)}</td>
                  <td>{item.selectedShippingMethod ?? "-"}</td>
                  <td>{new Date(item.lastActivityAt).toLocaleString("pt-BR")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
